export function useToast() {
  const message = useState<string | null>('toast-message', () => null)
  const type = useState<string>('toast-type', () => '')
  let timer: ReturnType<typeof setTimeout> | null = null

  function show(text: string, toastType = '') {
    message.value = text
    type.value = toastType
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      message.value = null
      type.value = ''
    }, 3500)
  }

  return { message, type, show }
}
